import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core'
import { OrgBrowserOrgList } from '../../models/org-browser-org-list';
import { OrgBrowserView } from '../../models/org-browser-view';

@Component({
    selector: 'pworg-selector',
    templateUrl: './pworg-selector.component.html',
    styleUrls: ['./pworg-selector.component.scss']
})

export class PWOrgSelectorComponent implements OnInit {

    @Output() addOrgList: EventEmitter<number> = new EventEmitter();
    constructor() { }

    ngOnInit() {
    }

    onOrgExpand(org: OrgBrowserView): void {
        this.addOrgList.emit(org.orgId);
    }

}